module.exports = __webpack_public_path__ + "img/荣誉证书10_质量管理体系认证证书.e0f39d08.png";